// init.js 改造版
import { getToken,setToken } from './utils/auth';
import { loadInterceptors } from './utils/request';
import { wxJsSDKInit, getCode, getAuth } from './utils/wx';
import { ddJsSdkInit, handleDingTalkLogin } from './utils/dingtalk'; // 引入钉钉逻辑
import { isDingTalk, isWeChat, isWeCom } from './utils/env'; // 引入环境判断
import { Notify } from 'vant';
import { loginByOpenId, getOpenId } from "@/api/bind";
import { setLocal, getLocal, removeLocal } from '@/utils/cookie';
const whiteList = [
  '/whitePage/teacherScore',
  '/whitePage/whiteBook',
  '/whitePage/login',
  '/login',
  '/whitePage/Report',
  '/whitePage/dinfo',
];

export async function init({ router }) {



  // 1. 基础拦截器加载
  loadInterceptors();

  // 2. 路由守卫
  router.beforeResolve(async (to, from, next) => {
    // 白名单直接放行
    if (whiteList.indexOf(to.path) !== -1) {
      next();
      return;
    }

    const hasToken = getLocal("Authorization"); // 假设这是你的Token判断标准

    

    if (hasToken) {
      // === 已登录逻辑 ===
      
      // 根据环境初始化SDK
      if (isDingTalk()) {
        // 钉钉初始化（如果需要）
        // await ddJsSdkInit(); 
        next();
      } else if (isWeChat() || isWeCom()) {
        // 微信初始化
        try {
           await wxJsSDKInit();
        } catch (e) {
           console.error('WX SDK Init Error', e);
        }
        next();
      } else {
        next();
      }
      
    } else {
      // === 未登录逻辑 ===
      
      // if (isDingTalk()) {
      //   // --- 钉钉登录流程 ---
      //   try {
      //     await handleDingTalkLogin(); // 获取免登码 -> 后端换Token
      //     next(); // 登录成功，继续
      //   } catch (error) {
      //     console.error("DingTalk Login Fail", error);
      //     Notify({ type: 'danger', message: '钉钉登录失败' });
      //     // 可以跳转到错误页或重试页
      //   }

      // } else if (isWeChat() || isWeCom()) {
        // --- 微信/企微登录流程 (保留你原有的逻辑结构) ---
        
        // 1. 获取 OpenId (如果本地没有)
      //   if (!getLocal('openId') || getLocal('openId') === 'null') {
      //      // 检查 URL 是否有 code
      //      const code = getCode();
      //      if (code) {
      //        // 有 code，换 OpenId
      //        await getOpenId({ wxCode: code }).then(({ data }) => {
      //          if (data.body) {
      //            setLocal('openId', data.body);
      //            // 拿到 OpenId 后，重新走一遍路由逻辑（去触发下面的 loginByOpenId）
      //            // 这里通常建议 replace 到去掉 code 的 URL，防止刷新报错
      //            // next({ ...to, replace: true }); 
      //          }
      //        });
      //      } else {
      //        // 无 code，去微信授权
      //        // 注意：企业微信的 AppID 和 授权 URL 可能与公众号不同，需在 getAuth 里做判断
      //        getAuth(); 
      //        return; // 终止路由，等待跳转
      //      }
      //   }

      //   // 2. 使用 OpenId 登录
      //   const currentOpenId = getLocal('openId');
      //   if (currentOpenId) {
      //     loginByOpenId({ openId: currentOpenId }).then(async res => {
      //        if (res && res.data.obj == "personBindErrorCode") {
      //          // 未绑定账号
      //          removeLocal("userInfo");
      //          removeLocal("Authorization");
      //          next({
      //            path: "/index",
      //            query: { backUrl: to.path },
      //          });
      //        } else {
      //          // 登录成功
      //          setLocal("userInfo", JSON.stringify(res.data.body));
      //          setLocal("Authorization", res.data.body.token);
               
      //          // 登录成功后初始化 SDK
      //          await wxJsSDKInit();
      //          next();
      //        }
      //      }).catch(error => {
      //        next({ path: "/500", query: { message: "登录失败" } });
      //      });
      //   }
      // } else {
      //   // 浏览器或其他环境
      //   next(); // 或者跳转到普通账号密码登录页
      // }

          // 3. 未登录，且不在白名单 -> 跳转登录页
      // 将目标页面作为参数传递，以便登录后跳回
      next({
        path: '/login',
        query: { redirect: to.fullPath } 
      })
    }
  });

  router.afterEach((to) => {
    Notify.clear();
    // 统一设置标题（钉钉和微信设置标题的方法不同，建议封装）
    setPageTitle(to.meta.title);
  });
}

// 统一设置标题
function setPageTitle(title) {
  if (!title) return;
  document.title = title;
  if (isDingTalk()) {
    // 钉钉修改标题有时需要特定API
    dd.biz.navigation.setTitle({ title: title });
  }
}